/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePromotionDto,
  PromotionDto,
  UpdatePromotionDto,
} from '../models/index';
import {
    CreatePromotionDtoFromJSON,
    CreatePromotionDtoToJSON,
    PromotionDtoFromJSON,
    PromotionDtoToJSON,
    UpdatePromotionDtoFromJSON,
    UpdatePromotionDtoToJSON,
} from '../models/index';

export interface CreateRequest {
    createPromotionDto: CreatePromotionDto;
}

export interface GetByIdRequest {
    id: number;
}

export interface RemoveRequest {
    id: number;
}

export interface UpdateRequest {
    id: number;
    updatePromotionDto: UpdatePromotionDto;
}

/**
 * 
 */
export class PromotionServiceApi extends runtime.BaseAPI {

    /**
     * Create a promotion. If active=true, deactivates any other active promotion of the same type.
     */
    async createRaw(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionDto>> {
        if (requestParameters['createPromotionDto'] == null) {
            throw new runtime.RequiredError(
                'createPromotionDto',
                'Required parameter "createPromotionDto" was null or undefined when calling create().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/promotion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePromotionDtoToJSON(requestParameters['createPromotionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionDtoFromJSON(jsonValue));
    }

    /**
     * Create a promotion. If active=true, deactivates any other active promotion of the same type.
     */
    async create(requestParameters: CreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionDto> {
        const response = await this.createRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a promotion by ID
     */
    async getByIdRaw(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/promotion/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionDtoFromJSON(jsonValue));
    }

    /**
     * Get a promotion by ID
     */
    async getById(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionDto> {
        const response = await this.getByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all promotions
     */
    async listRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PromotionDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/promotion`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PromotionDtoFromJSON));
    }

    /**
     * List all promotions
     */
    async list(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PromotionDto>> {
        const response = await this.listRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete a promotion
     */
    async removeRaw(requestParameters: RemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling remove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/promotion/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionDtoFromJSON(jsonValue));
    }

    /**
     * Delete a promotion
     */
    async remove(requestParameters: RemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionDto> {
        const response = await this.removeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a promotion. Activating it deactivates any other active promotion of the same type.
     */
    async updateRaw(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling update().'
            );
        }

        if (requestParameters['updatePromotionDto'] == null) {
            throw new runtime.RequiredError(
                'updatePromotionDto',
                'Required parameter "updatePromotionDto" was null or undefined when calling update().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/promotion/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePromotionDtoToJSON(requestParameters['updatePromotionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionDtoFromJSON(jsonValue));
    }

    /**
     * Update a promotion. Activating it deactivates any other active promotion of the same type.
     */
    async update(requestParameters: UpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionDto> {
        const response = await this.updateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
